import OsamLogo from './OsamLogo';

export default OsamLogo;
